// extracted by mini-css-extract-plugin
export default {"sections":"Vita_sections__3jDAm","section":"Vita_section__4Tu07","yearText":"Vita_yearText__CXORe"};